<template>
    <li class="has-dropdown notifications" v-permission:manage_users="currentUser">
        <a href="#" @click.prevent="togglePopup"><i class="icon icon-notifications"></i> <span class="count" v-if="newNotifications > 0">{{ newNotifications }}</span> </a>

        <NotificationCenter :notifications="notifications" v-if="popup" @togglePopup="togglePopup"></NotificationCenter>

        <div class="notification-flash" v-if="flash">
            <p>{{ flash.message }}</p>
            <small>{{ flash.date | formatDate }}</small>
        </div>
    </li>
</template>

<script>
	import moment from 'moment-timezone'
	import { mapGetters } from 'vuex'
	import { FETCH_NOTIFICATIONS } from '@/store/modules/notifications'
	import { ADD_NOTIFICATION } from '@/store/modules/notifications'
	import NotificationCenter from './NotificationCenter'

	export default {
		components: { NotificationCenter },

		data () {
			return {
				popup: false,
				newNotifications: 0,
				flash: null,
			}
		},

		computed: {
			...mapGetters([
				'notifications',
				'currentUser',
			]),
		},

		mounted () {
			this.fetchData()

			window.Echo.private('notifications.admin').listen('PropertyInspectionCompleted', (data) => {
				this.$store.dispatch(ADD_NOTIFICATION, { id: null, channel: 'admin', message: data.message, created_at: moment().format() })
				this.newNotifications++

				this.setFlashMessage({
					message: data.message,
					date: moment().format(),
				})
			})

			window.Echo.private('notifications.admin').listen('UnapprovedPropertyAdded', (data) => {
				this.$store.dispatch(ADD_NOTIFICATION, { id: null, channel: 'admin', message: data.message })
				this.newNotifications++

				this.setFlashMessage({
					message: data.message,
					date: moment().format(),
				})
			})
		},

		filters: {
			formatDate (value) {
				return moment().utc(value).format('LLL')
			},
		},

		methods: {
			fetchData () {
				this.$store.dispatch(FETCH_NOTIFICATIONS)
			},

			togglePopup () {
				if (this.popup === false) {
					this.newNotifications = 0
				}

				this.popup = !this.popup
			},

			setFlashMessage (object) {
				let curObj = this
				this.flash = object

				setTimeout(() => {
					curObj.flash = null
				}, 4000)
			},
		},
	}
</script>

<style scoped lang="scss">
    .notification-flash {
        position: fixed;
        background: #0085ad;
        border-radius: 4px;
        border-color: #e6e6e6;
        top: 85px;
        right: 15px;
        padding: 15px;
        width: 300px;
        color: #FFF;

        p {
            margin-bottom: 0;
        }
    }
</style>